export const firebaseConfig = {
    apiKey: "AIzaSyDTGfSQqjke15YBtaT1kfOzolkKoD4BG5I",
    authDomain: "artxplorer.firebaseapp.com",
    databaseURL: "https://artxplorer-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "artxplorer",
    storageBucket: "artxplorer.firebasestorage.app",
    messagingSenderId: "78923017289",
    appId: "1:78923017289:web:85860650e87b4463142398"
  };